import React from 'react'
import { MetricHeightField } from './MetricHeightField'
import { StandardHeightFields } from './StandardHeightFields'

export const HeightField = ({
  field,
  form,
  hint,
  labelClassName,
  measurementField,
  requirementLabel
}) => {
  const { errors, touched, values } = form
  const errorMessage =
    touched && touched[field.name] && errors && errors[field.name]

  const Component =
    values[measurementField] === 'metric'
      ? MetricHeightField
      : StandardHeightFields

  const componentProps = {
    errorMessage,
    field,
    form,
    hint,
    label: 'Height (approximate)',
    labelClassName,
    requirementLabel
  }

  return <Component {...componentProps} />
}
